export default __webpack_public_path__ + "static/menu-dont-dark-9ac1438495832c3c5276d70dd161eec16e677f6f2f5a7e1bcaf6276104a3f63c.png";